import KBArticle from 'conversations-visitor-experience-components/knowledge-base/KBArticle';
import { useKBArticle } from '../kbArticleSelectors';
import { getVisitorIdentification } from '../../visitor-identity/operators/getVisitorIdentificationEnabled';
import { useSelector } from 'react-redux';
import { getIfSelectedKBIsLatest } from '../../selectors/widgetDataSelectors/getIfSelectedKBIsLatest';
import { jsx as _jsx } from "react/jsx-runtime";
function KBArticleContainer() {
  const kbArticle = useKBArticle();
  const visitorIdentification = useSelector(getVisitorIdentification);
  const selectedKBIsLatest = useSelector(getIfSelectedKBIsLatest);
  return /*#__PURE__*/_jsx(KBArticle, {
    kbArticle: kbArticle,
    visitorIdentification: visitorIdentification,
    isKnowledgeBaseV3: selectedKBIsLatest
  });
}
KBArticleContainer.displayName = 'KBArticleContainer';
export default KBArticleContainer;